import apiClient from '../api';
import { executeAndWaitResponse } from './service';

export const all = async () => executeAndWaitResponse(
  () => apiClient.giftcards.all(),
);

export const get = async (hash) => executeAndWaitResponse(
  () => apiClient.giftcards.get(hash),
);
export const update = async (hash, data) => executeAndWaitResponse(
  () => apiClient.giftcards.update(hash, data),
);
export const sendReceiverEmail = async (hash, email) => executeAndWaitResponse(
  () => apiClient.giftcards.sendReceiverEmail(hash, email),
);
export const create = async (data) => executeAndWaitResponse(
  () => apiClient.giftcards.create(data),
);
export const remove = async (hash) => executeAndWaitResponse(
  () => apiClient.giftcards.update(hash, { status: 'DELETED' }),
);

export default {
  all,
  create,
  update,
  remove,
  get,
  sendReceiverEmail,
};
